import { useDispatch } from 'react-redux';
import { Box, Icon } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';
import { toggleEditModal } from '@/store/slices/components/calendarEvents/CalendarEventsSlice';

export default function VisitCell({ id, name }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(toggleEditModal({ id }));
  };

  if (!id)
    return <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />;

  return (
    <Box className={styles.visitCell} onClick={handleClick}>
      {name}
    </Box>
  );
}
